import { StyleSheet, Font } from "@react-pdf/renderer";
import MulishBlack from "../../../static/fonts/Mulish/Mulish-Black.ttf";

Font.register({
  family: "Mulish",
  fonts: [{ src: MulishBlack, fontWeight: 900 }],
});

export const wasteQualityStyleSheet = StyleSheet.create({
  chartContent: {
    marginTop: "10px",
    paddingHorizontal: 20,
    flexDirection: "row",
    alignItems: "flex-start",
  },

  volumeContent: {
    paddingLeft: 20,
    paddingRight: 20,
    marginTop: -20,
    flexDirection: "row",
  },

  materialContent: {
    paddingLeft: 20,
    paddingRight: 20,
    flexDirection: "row",
  },

  tableContent: {
    paddingLeft: 20,
    paddingRight: 20,
    flexDirection: "row",
  },

  ChartTitle: {
    fontSize: 18,
    color: "#00A7A6",
    fontFamily: "Mulish",
    fontWeight: 1000,
    letterSpacing: "1px",
  },

  stats: {
    fontSize: 18,
    fontFamily: "Mulish",
    color: "#e81d7a",
    fontWeight: 1000,
    marginTop: 50,
  },

  text: {
    fontSize: 12,
    fontFamily: "Mulish",
  },

  textSmall: {
    fontSize: 10,
    fontFamily: "Mulish",
  },

  legendText: {
    fontSize: 10,
    fontFamily: "Mulish",
  },

  image: {
    flex: 7,
    width: "380px",
    height: "380px",
  },

  materialChart: {
    width: "390px",
    height: "350px",
    alignSelf: "flex-end",
  },

  caracterisationLogo: {
    width: 28,
    height: 38,
    marginRight: 2,
  },

  caracterisationAndStats: {
    marginVertical: 3,
    height: "25%",
    width: "100%",
    flexDirection: "row",
  },
  caracterisationContainer: {
    fontSize: 26,
    fontFamily: "Mulish",
    color: "#e81d7a",
    fontWeight: 500,
  },
  caracterisationText: {
    fontSize: 12,
    fontFamily: "Mulish",
    color: "#0F265C",
    fontWeight: 500,
  },

  noticeText: {
    width: "100%",
    flexDirection: "row",
  },

  notice: {
    fontSize: 14,
    fontFamily: "Mulish",
    color: "#e81d7a",
    marginRight: 1,
    marginTop: -3,
    fontWeight: 500,
  },
  outletInfoText: {
    marginTop: "1%",
    fontSize: 12,
    textSpacing: "1px",
    fontWeight: 500,
    fontFamily: "Mulish",
    color: "rgb(15, 38, 92)",
  },
  outletRepartition: {
    paddingLeft: 20,
    paddingRight: 20,
    flexDirection: "row",
    marginTop: 30,
  },
  outletChart: {
    flex: 7,
    alignItems: "flex-end",
    marginTop: 20,
  },
  outletChartImage: {
    // Mise en page d'origine : camembert à droite du titre, dans sa colonne.
    // Le gain de taille vient du rayon augmenté à la capture (78%).
    width: "390px",
    height: "350px",
    alignSelf: "flex-end",
  },
  wrapper: {
    marginTop: 10,
    flexDirection: "column",
    width: "100%",
  },
  alertRow: {
    flexDirection: "row",
    alignItems: "center",
    marginBottom: 6,
  },
  alertIcon: {
    fontSize: 14,
    color: "#FF0000",
    marginRight: 6,
  },
  alertText: {
    fontSize: 12,
    color: "#E81D7A",
    fontWeight: "bold",
  },
  categoryRow: {
    flexDirection: "row",
    justifyContent: "space-between",
    width: "100%",
    marginBottom: "10px",
  },
  leftCol: {
    flexDirection: "column",
  },
  categoryName: {
    fontSize: 11,
    fontWeight: 900,
    color: "#1E3363", // dark blue
    marginBottom: "5px",
  },
  categoryPercent: {
    fontSize: 12,
    fontWeight: 900,
    color: "#E81D7A", // pink
  },
  rightCol: {
    flexDirection: "column",
    fontSize: 10,
    color: "#1E3363",
    textAlign: "right",
  },
  boldValue: {
    fontWeight: 900,
  },
});
